module.exports = __webpack_public_path__ + "img/guest-def.8e909576.jpg";